(() => {
  const initialize = (section) => {
    if (section.dataset.clubMostSoldReady === 'true') return;

    const track = section.querySelector('[data-club-most-sold-track]');
    if (!track) return;

    const previousButton = section.querySelector('[data-club-most-sold-previous]');
    const nextButton = section.querySelector('[data-club-most-sold-next]');

    section.dataset.clubMostSoldReady = 'true';

    const scrollTrack = (direction) => {
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      track.scrollBy({ left: direction * Math.round(track.clientWidth * 0.86), behavior });
    };

    const updateControls = () => {
      const maximumScroll = track.scrollWidth - track.clientWidth;
      const hasOverflow = maximumScroll > 1;

      if (previousButton) previousButton.hidden = !hasOverflow || track.scrollLeft <= 1;
      if (nextButton) nextButton.hidden = !hasOverflow || track.scrollLeft >= maximumScroll - 1;
    };

    track.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      scrollTrack(event.key === 'ArrowRight' ? 1 : -1);
    });

    if (previousButton) previousButton.addEventListener('click', () => scrollTrack(-1));
    if (nextButton) nextButton.addEventListener('click', () => scrollTrack(1));

    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-club-most-sold]').forEach(initialize);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
